import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd2631a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "headerWrapper",
  id: "top"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "homepage-logo-mobile"
}
const _hoisted_4 = { class: "box logo-wrapper" }
const _hoisted_5 = { class: "homepage-logo" }
const _hoisted_6 = { class: "box linksWrapper" }
const _hoisted_7 = { class: "box shopping-button-wrapper" }

import HeaderTabs from "./HeaderTabs.vue";
import ShoppingButton from "./ShoppingButton.vue";

import { PropType, onMounted, onUnmounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  props: {
  links: {
    type: Array as PropType<{ linkText: string; linkTo: string }[]>,
    required: false,
    default: () => [],
  },
},
  setup(__props) {



const state = reactive({
  screenWidth: 0,
});

onMounted(() => {
  window.addEventListener("resize", handleWindowSizeChange);
  handleWindowSizeChange();
});
onUnmounted(() => {
  window.removeEventListener("resize", handleWindowSizeChange);
});
const handleWindowSizeChange = () => {
  state.screenWidth = window.innerWidth;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (state.screenWidth < 480)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "icon-link"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "logo-mobile")
              ]),
              _: 3
            }),
            _createVNode(ShoppingButton)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "left")
            ]),
            _: 3
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(HeaderTabs, { tabs: __props.links }, null, 8, ["tabs"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "right", {}, () => [
          _createVNode(ShoppingButton)
        ])
      ])
    ])
  ]))
}
}

})